import { render } from "./MusicSports.vue?vue&type=template&id=0f8a4b27&scoped=true"
import script from "./MusicSports.vue?vue&type=script&lang=js"
export * from "./MusicSports.vue?vue&type=script&lang=js"

import "./MusicSports.vue?vue&type=style&index=0&id=0f8a4b27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8a4b27"]])

export default __exports__